import { IonIcon } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline, closeOutline } from 'ionicons/icons';

interface PhotoViewerControlsProps {
  index: number;
  count: number;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}

const ROUND_BUTTON =
  'absolute flex h-10 w-10 items-center justify-center bg-black/50 text-white cursor-pointer';

/**
 * Overlay of the full-screen photo viewer: close button, previous/next chevrons
 * (hidden at the ends) and a "2 / 4" counter when there is more than one photo.
 */
export const PhotoViewerControls = ({ index, count, onClose, onPrev, onNext }: PhotoViewerControlsProps) => (
  <>
    <button
      type="button"
      className={`${ROUND_BUTTON} right-3`}
      style={{ borderRadius: '9999px', padding: 0, top: 'calc(var(--ion-safe-area-top, 0px) + 12px)' }}
      onClick={onClose}
      aria-label="Cerrar"
    >
      <IonIcon icon={closeOutline} className="text-2xl" aria-hidden="true" />
    </button>

    {index > 0 && (
      <button
        type="button"
        className={`${ROUND_BUTTON} left-3 top-1/2 -translate-y-1/2`}
        style={{ borderRadius: '9999px', padding: 0 }}
        onClick={onPrev}
        aria-label="Foto anterior"
      >
        <IonIcon icon={chevronBackOutline} className="text-2xl" aria-hidden="true" />
      </button>
    )}

    {index < count - 1 && (
      <button
        type="button"
        className={`${ROUND_BUTTON} right-3 top-1/2 -translate-y-1/2`}
        style={{ borderRadius: '9999px', padding: 0 }}
        onClick={onNext}
        aria-label="Foto siguiente"
      >
        <IonIcon icon={chevronForwardOutline} className="text-2xl" aria-hidden="true" />
      </button>
    )}

    {count > 1 && (
      <div
        className="absolute left-1/2 -translate-x-1/2 bg-black/50 px-3 py-1 text-sm text-white"
        style={{ borderRadius: '9999px', bottom: 'calc(var(--ion-safe-area-bottom, 0px) + 16px)' }}
      >
        {index + 1} / {count}
      </div>
    )}
  </>
);
